import { render, staticRenderFns } from "./personagePhone.vue?vue&type=template&id=b0dd31e8&scoped=true&"
import script from "./personagePhone.vue?vue&type=script&lang=js&"
export * from "./personagePhone.vue?vue&type=script&lang=js&"
import style0 from "./personagePhone.vue?vue&type=style&index=0&id=b0dd31e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dd31e8",
  null
  
)

export default component.exports